<div class="container" #container>
    <div class="overlay" (click)="overlayClicked()"></div>
    <div *ngFor="let item of items" class="menu-item-container">
        <hr *ngIf="itemIsDivider(item)" />
        <div *ngIf="!itemIsDivider(item)" class="menu-item" (click)="itemClicked(item)">{{item.text}}</div>
    </div>
</div>
